export default function getResource(label, vars = []) {
    const resources = {
        reviewsLabel: `${vars[0]}`,
        writeReview: 'Rédiger un commentaire',
        ratingsReviews: 'Résumé des évaluations',
        seeAllReviews: 'Voir tous les commentaires',
        closeButton: 'Fermer'
    };
    return resources[label];
}
